export default __webpack_public_path__ + "static/media/adobe-logo.bc154f16.svg";